import { NgModule } from '@angular/core';
import { TranslationModule } from './translation.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { serviceProviders } from '../../models';
import { SharedModule } from '../shared.module';
import { IconModule } from './icon.module';
import { EtherDecimalFixedModule } from './ether-decimal-fixed.module';
import { SaleManagementComponent } from 'src/app/widgets/sale-management';

@NgModule({
  imports: [
    TranslationModule,
    MatDialogModule,
    MatButtonModule,
    FlexLayoutModule,
    IconModule,
    EtherDecimalFixedModule,
    SharedModule,
  ],
  providers: [...serviceProviders],
  declarations: [SaleManagementComponent],
  exports: [
    SaleManagementComponent,
    TranslationModule,
    IconModule,
    EtherDecimalFixedModule,
    FlexLayoutModule,
  ],
  bootstrap: [],
  entryComponents: [SaleManagementComponent],
  schemas: [],
})
export class SaleManagementDialogModule {}
